module.exports = __webpack_public_path__ + "static/media/poste_17.d41f4a1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_17.jpg
// module id = 245
// module chunks = 0